<template>
    <v-app>
        <Background />

        <transition name="fade">
            <Navigation @clicked="showDrawer=!showDrawer" v-if="showUIBar"/>
        </transition>

        <Drawer v-model="showDrawer" />
        <Alert />
        <Content/>
        <Footer v-if="showUIBar"/>
        <FabButton />
    </v-app>
</template>

<script>
import Navigation from "./components/core/Navigation";
import Background from "./components/core/Background";
import Content from "./components/core/Content";
import Footer from "./components/core/Footer";
import Drawer from "./components/core/Drawer";

import Alert from "./components/overlay/Alert";
import FabButton from "./components/overlay/FabButton";
import { genSearchProductType } from "./services/constants";

export default {
    name: "App",
    components: {
		Navigation,
        Background,
        Content,
        Footer,
        Drawer,
        Alert,
        FabButton
    },
    data() {
        return {
            showDrawer: false,
        };
    },
    beforeMount() {
        this.$store.dispatch("Restore");
        this.$store.dispatch({type: "GetRoute", query: this.$route.query})
            .then((route) => genSearchProductType(route));
    },
    mounted() {
        // console.log(this.$vuetify.breakpoint);
        
        console.log(
        `%c Marketpett %c Do not enter or paste code that you do not understand. %c'Self-XSS'`,
        'background:#335496 ; padding: 2px; border-radius: 3px 3px;  color: #fff',
        'background:transparent',
        'font-weight: bold'
      )
    },
    computed: {
        showUIBar() {
            // nav and footer
            let { path } = this.$route;
            // return true;
            return !(path === '/login' || path === '/register' || path === '/resetpassword');
        }
    }
};

// ============================================
//  Global, Add constructor function prototype
// ============================================

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

</script>

<style lang="scss">
@import "./sass/global.scss";
</style>
